import { Component, effect, input, model, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { DateUtils, Time } from '@spaces-ui/utils';

import { MdwDatePicker } from '../date-picker/date-picker';
import { MdwTimePicker } from '../time-picker/time-picker';

interface DateTimeForm {
  date: FormControl<Date | undefined>;
  time: FormControl<Time | undefined>;
}

@UntilDestroy()
@Component({
  selector: 'mdw-date-time-picker',
  templateUrl: './date-time-picker.html',
  styleUrls: ['./date-time-picker.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwDatePicker, MdwTimePicker, ReactiveFormsModule],
})
export class MdwDateTimePicker {
  public value = model<Date | undefined>();
  public filterType = input<'future' | 'past' | 'none'>('none');

  public formGroup?: FormGroup<DateTimeForm>;

  public constructor() {
    effect(() => {
      const value = this.value();

      if (!this.formGroup) {
        const time = value ? DateUtils.getTime(value) : undefined;
        this.formGroup = new FormGroup<DateTimeForm>({
          date: new FormControl<Date | undefined>(value, { nonNullable: true }),
          time: new FormControl<Time | undefined>(time, { nonNullable: true }),
        });

        this.formGroup.valueChanges.pipe(untilDestroyed(this)).subscribe(newValue => {
          const { date, time } = newValue;

          if (!date || !time) {
            this.value.set(undefined);
            return;
          }

          const dateTime = DateUtils.combineDateAndTime(date, time);
          this.value.set(dateTime);
        });
      }
    });
  }
}
